module.exports = __webpack_public_path__ + "img/express-delivery2.54923b9.svg";